import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ReceiptTextIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { useScrolledPast } from '../hooks/useScrolledPast';
import { site } from '../data/landing';
export function StickyHeader() {
  const scrolled = useScrolledPast(480);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-200 ease-out ${scrolled ? 'border-b border-white/10 bg-ink/95 backdrop-blur' : 'border-b border-transparent bg-transparent'}`} data-id="element-195" data-mp="1dso6ochqvvz4">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6" data-id="element-196" data-mp="zsvmz14myg0n">
        <a href="#top" className="flex items-center gap-2 text-white" aria-label={site.productName} data-id="element-197" data-mp="v156edf3uw0s">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary" data-id="element-198" data-mp="7bj77pyqggss">
            <ReceiptTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-199" data-mp="2cznzxbixj44" />
          </span>
          <span className="text-base font-extrabold tracking-tight" data-id="element-200" data-mp="2b58wzmxol7y">
            Cotizador <span className="text-success-light" data-id="element-201" data-mp="880qkenwe6th">PRO</span>
            <span className="ml-1.5 rounded bg-white/10 px-1.5 py-0.5 text-[10px] font-bold text-slate-300" data-id="element-202" data-mp="d6kayamufajq">VE</span>
          </span>
        </a>
        <AnimatePresence data-id="element-203" data-mp="i06ridw4nykt">
          {scrolled && <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-204" data-mp="lzxdm4aplqj0">
              <CtaButton size="md" data-id="element-205" data-mp="3qfqdcrugyepu">Comprar · {site.price}</CtaButton>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}